import { HypotheticalSaleLoanKind } from '@/types/schema';
import { UnreachableError } from '@/utils/errors';

export function getSaleLoanKindDisplay(
  kind: HypotheticalSaleLoanKind,
  opts?: {
    short?: boolean;
  }
): string {
  switch (kind) {
    case HypotheticalSaleLoanKind.Sale:
      return opts?.short ? 'Sale' : 'Installment sale';
    case HypotheticalSaleLoanKind.Loan:
      return opts?.short ? 'Loan' : 'Intra-family loan';
    default:
      throw new UnreachableError({
        case: kind,
        message: `Invalid hypothetical sale/loan kind specified: ${kind}`,
      });
  }
}
